import { Injectable } from '@angular/core';
import { PAGE_STATES } from '../Constants/SELECT_CONSTS';

@Injectable({
  providedIn: 'root',
})
export class SessionServiceService {
  constructor() {}

  public setValue(pageState: PAGE_STATES | string, prop: SessionsFields, value: any): void {
    const key = this.getSessionKey(pageState, prop);
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  public removeItem(pageState: PAGE_STATES | string, prop: SessionsFields): void {
    const key = this.getSessionKey(pageState, prop);
    sessionStorage.removeItem(key);
  }

  public getValue<T>(pageState: PAGE_STATES | string, prop: SessionsFields): T | null {
    const key = this.getSessionKey(pageState, prop);
    const value = sessionStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : null;
  }

  private getSessionKey(pageState: PAGE_STATES | string, formField: SessionsFields): string {
    return `${pageState}_${formField}`;
  }
}

export enum SessionsFields {
  flowRate = 'flowRate',
  flowRateUnit = 'flowRateUnit',
  pressure = 'pressure',
  staticPressure = 'staticPressure',
  mainPumps = 'mainPumps',
  backupPumps = 'backupPumps',
  isNoUsePumpCount = 'isNoUsePumpCount',
  liquid = 'liquid',
  concentration = 'concentration',
  tLiquid = 'tLiquid',
  calculationType = 'calculationType',
  withSeparationValvesOnCollectors = 'withSeparationValvesOnCollectors',
  stainlessSteel = 'stainlessSteel',
  cataphoresisSteel = 'cataphoresisSteel',
  isUseExplosionProtectionType = 'isUseExplosionProtectionType',
  isCuttingMechanism = 'isCuttingMechanism',
  wpsString = 'wpsString',
  articleSystemDataString = 'articleSystemDataString',
  flowRateInputRaw = 'flowRateInputRaw',

  state = 'state',
  pumpArticle = 'article',
  seriesIds = 'seriesIds',
}
